import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineCloudUploadIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M18.42 8.22a7 7 0 0 0-13.36 1.89 3.9997 3.9997 0 0 0-3.0403 4.3632A4.0002 4.0002 0 0 0 6 18a.9997.9997 0 0 0 1-1 1 1 0 0 0-1-1 1.9999 1.9999 0 1 1 0-4 .9997.9997 0 0 0 1-1 5 5 0 0 1 9.73-1.61 1.0001 1.0001 0 0 0 .78.67 3 3 0 0 1 .24 5.84 1.0018 1.0018 0 0 0 .5 1.94 5 5 0 0 0 .17-9.62Zm-5.71 2.07a1.0002 1.0002 0 0 0-.33-.21c-.2435-.1-.5165-.1-.76 0a1.0012 1.0012 0 0 0-.33.21l-3 3a1.0041 1.0041 0 0 0 1.42 1.42l1.29-1.3V19a1.0001 1.0001 0 0 0 2 0v-5.59l1.29 1.3a.9997.9997 0 0 0 1.42 0 .9998.9998 0 0 0 0-1.42l-3-3Z"/>
  </SvgIcon>
}

export default LineCloudUploadIcon
